import { ServerCmdProviderBase } from '../../core/cmd/ServerCmdProviderBase.js';
import { ViewServerCommand } from './ViewServerCommand.js';
import { ViewUiCommand } from './ViewUiCommand.js';

/**
* Провайдер серверных команд для view-сценариев.
* Адаптирует ответы сервера в команды пространства имен `view`.
*/
class ViewServerCmdProvider extends ServerCmdProviderBase {
    constructor() {
        super(...arguments);
        /** Уникальный ключ провайдера (для логов/отладки) */
        this.id = "ViewWidget";
        /** Приоритет обработки */
        this.priority = 0;
    }
    /** Список поддерживаемых типов серверных команд */
    getSupported() {
        return Object.values(ViewServerCommand);
    }
    /**
    * Адаптирует серверную команду closeView в набор UI-токенов.
    * @param cmd Данные серверной команды
    * @param _ctx Контекст выполнения UI-команд (не используется)
    */
    adapt(cmd, _ctx) {
        const t = [];
        const maskStr = this.makeMaskStr(cmd.mask, cmd.area);
        /** Закрыть view */
        switch (cmd.type) {
            case ViewServerCommand.close: {
                t.push(`view::${ViewUiCommand.closeView}|${maskStr ?? ""}|${!!cmd.viewOnly}|true`);
                break;
            }
            case ViewServerCommand.reload: {
                t.push(`view::${ViewUiCommand.reload}|${maskStr ?? ""}|${cmd.items ?? ""}`);
                break;
            }
            case ViewServerCommand.refresh: {
                t.push(`view::${ViewUiCommand.refresh}|${maskStr ?? ""}|${cmd.items ?? ""}`);
                break;
            }
            case ViewServerCommand.setRequiredValues: {
                console.info('ViewServerCommand.setRequiredValues', cmd.value);
                t.push({
                    raw: `view::${ViewUiCommand.setRequiredValues}`,
                    namespace: "view",
                    command: ViewUiCommand.setRequiredValues,
                    rawArgs: [maskStr ?? "", cmd.value],
                });
                break;
            }
            case ViewServerCommand.reloadElement: {
                if (!maskStr?.trim()) {
                    console.error("[ViewServerCmdProvider.reloadElement] Пустая mask недопустима для reloadItem");
                    break;
                }
                console.log(`[ViewServerCmdProvider.reloadElement] ${maskStr}`);
                t.push(`view::${ViewUiCommand.reloadItem}|${maskStr}`);
                break;
            }
            case ViewServerCommand.reloadResult: {
                t.push({
                    raw: "view::reloadResult",
                    namespace: "view",
                    command: ViewUiCommand.reloadResult,
                    rawArgs: [],
                    targetMask: cmd.item ? this.makeMask(`[data-key=${cmd.item}]`, cmd.area) : undefined,
                    solvedArgs: { itemMode: !!cmd.item, html: cmd.html },
                });
                break;
            }
            case ViewServerCommand.saved:
                {
                    t.push(`view::${ViewUiCommand.saved}`);
                }
                break;
            case ViewServerCommand.setFormMode:
                {
                    t.push(`view::${ViewUiCommand.setFormMode}|${cmd.mode}`);
                }
                break;
        }
        return this.makeResult(t);
    }
}

export { ViewServerCmdProvider };
